import {AxiosError} from 'axios';
import {useMutation} from 'react-query';
import {toast} from 'react-toastify';
import PostSeedRequirement from '.';

interface IPostPesticideRequirementProps {
  onSuccess?: (response: IAddedAdvertisementResponse) => void;
}

const usePostSeedRequirement = ({
  onSuccess,
}: IPostPesticideRequirementProps) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: ISeedRequirementPayload) => {
      return PostSeedRequirement(payload);
    },
    onSuccess: data => {
      onSuccess && onSuccess(data);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export {usePostSeedRequirement};
